import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const ObservationBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge className="border-transparent bg-yellow-500 text-foreground">
      {t('component:badge.observation')}
    </Badge>
  );
};
